import { getProfileDisplayName } from "../../utils/profiles";

export default function DisplayName({ profile }) {
  return getProfileDisplayName(profile);
}
